<template>
    <div class="px-8 py-6">
        <div class="flex h-full items-center justify-center"  v-if="loading">
            <IconLoadingCats/>
        </div>
        <div v-html="claimData" class="text-black" v-else>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { getPatentClaimData } from '@/infrastructure/api-functions';
import { ref, watch, computed, onBeforeUnmount } from 'vue';
import IconLoadingCats from '@/components/icons/IconLoadingCats.vue'
import { TRANSLATE_LANGUAGES, type IdeaContent } from '@/types';
import { splitText } from '@eureka/utils/text'

const props = defineProps<{
    translateMode: TRANSLATE_LANGUAGES,
    inputLang: TRANSLATE_LANGUAGES,
    editContent: IdeaContent
}>()
const claimData = ref('')
const route = useRoute();
const patentId = computed(() => route.params.id as string)
const loading = ref(false)

const stopWatcher = watch(
    () => { return [props.translateMode, patentId.value] },
    () => {
        if (props.translateMode === TRANSLATE_LANGUAGES.NONE) return
        loading.value = true
        getPatentClaimData(
            {
                lang: props.inputLang,
                trans_lang: props.translateMode,
                patent_id: patentId.value,
                means: props.editContent.means,
                efficacy: props.editContent.efficacy,
            }
        ).then(
            res => {
                claimData.value = splitText(res.CLMS).map(p => `<p class="mb-1.5 last:mb-0">${p}</p>`).join('')
            }
        ).finally(() => {
            loading.value = false
        })
    },
    {
        immediate: true,
        flush: 'post',
    }
)

onBeforeUnmount(() => {
    stopWatcher();
});
</script>
